import { Link } from "@tanstack/react-router";
import { InstanceBrandLockup } from "@/components/instance/InstanceBrandingProvider";
import { PRODUCT_HOME } from "@/lib/product";

export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="relative grid min-h-screen w-full place-items-center overflow-hidden px-4 py-10">
      <div className="pointer-events-none absolute inset-0 -z-10" style={{ background: "var(--gradient-aurora)" }} />
      <div className="w-full max-w-md">
        <Link to={PRODUCT_HOME} className="mb-6 flex items-center justify-center gap-2.5">
          <InstanceBrandLockup />
        </Link>

        <div className="glass-strong rounded-2xl p-7">
          <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>
          <div className="mt-6">{children}</div>
        </div>

        {footer && <div className="mt-5 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  );
}

export function SocialButton({
  onClick,
  href,
  icon,
  label,
}: {
  onClick?: () => void;
  href?: string;
  icon: React.ReactNode;
  label: string;
}) {
  const className = "flex h-11 w-full items-center justify-center gap-2.5 rounded-xl border hairline bg-soft px-4 text-sm font-medium transition hover:bg-[var(--soft-fill)] hover:text-foreground";

  if (href) {
    return (
      <a href={href} className={className}>
        {icon}
        <span>{label}</span>
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}

export function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.4 14.6 2.5 12 2.5 6.8 2.5 2.6 6.7 2.6 12s4.2 9.5 9.4 9.5c5.4 0 9-3.8 9-9.2 0-.6-.1-1.1-.2-1.6H12z" />
    </svg>
  );
}

export function GitHubIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M12 .5C5.65.5.5 5.66.5 12.02c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56 0-.27-.01-1.17-.02-2.13-3.2.7-3.88-1.36-3.88-1.36-.52-1.34-1.28-1.69-1.28-1.69-1.04-.72.08-.7.08-.7 1.15.08 1.75 1.18 1.75 1.18 1.02 1.76 2.68 1.25 3.33.96.1-.74.4-1.25.73-1.54-2.56-.29-5.25-1.28-5.25-5.72 0-1.27.45-2.3 1.18-3.11-.12-.29-.51-1.48.11-3.08 0 0 .97-.31 3.18 1.19A10.98 10.98 0 0 1 12 6.07c.97 0 1.95.13 2.86.38 2.21-1.5 3.18-1.19 3.18-1.19.62 1.6.23 2.79.11 3.08.73.81 1.18 1.84 1.18 3.11 0 4.45-2.69 5.42-5.26 5.71.41.36.77 1.06.77 2.15 0 1.55-.01 2.8-.01 3.18 0 .31.21.67.8.55 4.56-1.52 7.85-5.83 7.85-10.91C23.5 5.66 18.35.5 12 .5Z" />
    </svg>
  );
}
